import { combineReducers } from 'redux';
import paymentMethod from './paymentMethod';
import invoices from './invoices';
import createInvoice from "./createInvoice";

export default combineReducers({
  paymentMethod,
  invoices,
  createInvoice
});
